import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import MenuItem from '@mui/material/MenuItem';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlSelect } from '../../common/ControlSelect';

const MIN_SPACING = 1;
const MAX_SPACING = 300;
const clampValue = (value: number) => Math.min(Math.max(value, MIN_SPACING), MAX_SPACING);

export const TextSpacingControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedElements;
    const element = elements?.[0] as ElementType & { lineHeight: number };

    const handleChange = (value: string) => {
        elements.forEach(element => element.set({ ['lineHeight']: clampValue(+value) / 100 }));
    };

    const getValue = () => {
        return Math.round(element?.['lineHeight'] * 100) || undefined;
    };

    return (
        <ControlSelect onChange={e => handleChange(e.target.value as string)} value={getValue()}>
            {Array.from(Array(300).keys()).map((_, index) => (
                <MenuItem key={index} value={index + 1}>
                    {index + 1}px
                </MenuItem>
            ))}
        </ControlSelect>
    );
});
